<script>
export default {
    name: "p-modal",
    data() {
        return {
            showModal : false,
            title: "titulo",
            message: "Mensagem",
            responseKey: "confirmModalResponse",
            confirmOnly: true,
            anyData : {} /* guarda qualquer dado que a view precisa que retorne */
        };
    },
    methods: {
        close() {
            this.showModal = false
        },
        confirm() {
            if(!this.confirmOnly){
                if (!this.anyData) {
                    this.$bus.$emit(this.responseKey, true);
                } else {
                    this.$bus.$emit(this.responseKey, true, this.anyData);
                }
            }
            this.close();
        },
        cancel() {
            if (!this.anyData) {
                this.$bus.$emit(this.responseKey, false);
            } else {
                this.$bus.$emit(this.responseKey, false, this.anyData);
            }
            this.close();
        }

    },

    created: function() {
        this.$bus.$on("confirModal",data => {
            this.confirmOnly = data.confirmOnly;
            this.title = data.title;
            this.message = data.message;
            this.responseKey = data.responseKey;
            this.showModal = true;
            this.anyData = data.anyData;
        })
    }
};
</script>
<template>
    <transition name="modal">
        <div class="p-modal" v-if="showModal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container col-sm-10 col-md-7">
                        <div class="modal-header">
                            {{title}}
                        </div>

                        <div class="modal-body" v-html="message"></div>

                        <div class="modal-footer">
                            <slot name="footer">
                                <button v-if="!confirmOnly" class="p-button btn-simple" @click="cancel">Não</button>
                                <button class="p-button btn-simple red text-white" @click="confirm">{{confirmOnly ? 'Ok':'sim'}}</button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/js/components/p-modal.vue